/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-26 21:31:55
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-27 13:41:14
 * @FilePath: /roboneo-web/src/utils/canvasHistory.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { Operation, FabricObject } from '@meitu/whee-infinite-canvas';
// eslint-disable-next-line import/no-cycle
import useCanvasStore from '$/store/useCanvasStore';

/**
 * 添加类型历史记录
 *
 * @export
 * @return {*}
 */
export function submitAddHistroy() {
  const { render, historyPlugins } = useCanvasStore.getState();
  const objects = render?._FC.getActiveObjects();
  if (!objects) return;
  const operations: Operation[] = [];
  const operation = historyPlugins?.baseAction.getAddOperation({
    objects,
  });
  if (!operation) return;
  operations.push(operation);
  historyPlugins?.submit(operations);
}

/**
 * 修改后提交历史记录
 *
 * @export
 * @param {() => void} callback
 * @return {*}
 */
export function submitModifyHistory(callback: () => void) {
  const { render, historyPlugins } = useCanvasStore.getState();
  const modifyActiveObject = render?._FC.getActiveObject();
  if (!modifyActiveObject) return;
  const beforeData = historyPlugins?.baseAction.getElementData({
    target: modifyActiveObject,
  }) ?? [];

  // 执行修改方法
  callback();

  // 获取修改后历史记录
  const modifiedActiveObject = render?._FC.getActiveObject();
  if (!modifiedActiveObject) return;
  const afterData = historyPlugins?.baseAction.getElementData({
    target: modifiedActiveObject,
  }) ?? [];
  const operation = historyPlugins?.baseAction.getModifiedOperation({
    beforeData,
    afterData,
  });
  if (!operation) return;
  historyPlugins?.submit(operation);
}

/**
 * 删除类型历史记录
 *
 * @export
 * @param {FabricObject[]} objects
 * @return {*}
 */
export function removeHistroy(objects: FabricObject[]) {
  const { historyPlugins } = useCanvasStore.getState();
  const operation = historyPlugins?.baseAction.getRemoveOperation({
    objects,
  });
  if (!operation) return;
  historyPlugins?.submit(operation);
}
